import { AccessList, DefaultPermissions } from 'interfaces/global/globalInterfaces';
import { isActive } from '../itson/ItsOn';

type Permissions = string[];

export const isAccessAllowed = (
  companyUuid: string | undefined,
  token: string,
  accessList: AccessList[],
  defaultPermissions: DefaultPermissions
): boolean => {
  if (!accessList || !accessList.length) {
    return false;
  }

  const userPermissions = accessList.find(({ company_uuid }) => company_uuid === companyUuid);

  const userRole = userPermissions?.access_control?.role;

  if (!userRole || !defaultPermissions) {
    return false;
  }

  const rolePermissions: Permissions = defaultPermissions[userRole];
  const personalPermissions: Permissions = userPermissions.access_control.permissions;

  const hasPermission = (permissions: Permissions) => permissions.some((permission) => permission === token);

  if (isActive('METASHARKSHR-688:remove_old_role_model_from_frontend')) {
    return hasPermission(personalPermissions) || hasPermission(rolePermissions);
  }

  if (userRole === 'hr_user' && hasPermission(personalPermissions)) {
    return true;
  }

  if (
    (userRole === 'hr_admin' || userRole === 'hr_account' || userRole === 'hr_watcher') &&
    hasPermission(rolePermissions)
  ) {
    return true;
  }

  return false;
};
